import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Select.module.scss';

const Select = ({
  id,
  name,
  label,
  defaultValue,
  value,
  onChange,
  error,
  comment,
  tooltip,
  children,
  inputRef,
  ...rest
}) => (
  <div className={cx(styles.wrapper, error && styles.hasError)}>
    {label && (
      <label htmlFor={id} className={styles.label}>
        {label}
        {tooltip && (
          <span className={styles.tooltip}>
            <i className="icon-info" />
            <span className={styles.tooltipContainer}>{tooltip}</span>
          </span>
        )}
      </label>
    )}
    <div className={styles.inputWrapper}>
      <select
        id={id}
        name={name}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        className={styles.input}
        ref={inputRef}
        {...rest}
      >
        {children}
      </select>
    </div>
    {error && <span className={styles.error}>{error}</span>}
    {comment && <span className={styles.comment}>{comment}</span>}
  </div>
);

export default Select;

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  error: PropTypes.string,
  comment: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

Select.defaultProps = {
  id: '',
  name: '',
  type: 'text',
  label: '',
  defaultValue: undefined,
  value: undefined,
  onChange: null,
  error: '',
  comment: '',
  tooltip: '',
  children: null,
  inputRef: null,
};
